/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAuswertungDetailsTypeEnum } from '../../models/lexplus-auswertung-details-type-enum';
import { LexplusStandortErfuellungsgradDto } from '../../models/lexplus-standort-erfuellungsgrad-dto';

export interface AuswertungenControllerGetStandortErfuellungsgradV1$Params {
  standortIDs?: Array<number>;
  bewilligungspflicht?: boolean;
  nachweispflicht?: boolean;

/**
 * What the detail card groups its bars by. When set, the response carries one entry per group.
 */
  detailsType?: LexplusAuswertungDetailsTypeEnum;
}

export function auswertungenControllerGetStandortErfuellungsgradV1(http: HttpClient, rootUrl: string, params?: AuswertungenControllerGetStandortErfuellungsgradV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusStandortErfuellungsgradDto>>> {
  const rb = new RequestBuilder(rootUrl, auswertungenControllerGetStandortErfuellungsgradV1.PATH, 'get');
  if (params) {
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('bewilligungspflicht', params.bewilligungspflicht, {});
    rb.query('nachweispflicht', params.nachweispflicht, {});
    rb.query('detailsType', params.detailsType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusStandortErfuellungsgradDto>>;
    })
  );
}

auswertungenControllerGetStandortErfuellungsgradV1.PATH = '/v1/auswertungen/standort-erfuellungsgrad';
